"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ausbildungProgress = void 0;
var _facades = require("../facades");
var _numbers = require("./numbers");
var ausbildungProgress = exports.ausbildungProgress = function ausbildungProgress(start, end) {
  var totalDuration = (0, _facades.differenceInSeconds)(start, end);
  var alreadyPassed = (0, _facades.differenceInSeconds)(start, new Date());
  var progressPercentage = Math.floor(alreadyPassed / totalDuration * 100);
  return (0, _numbers.valBetween)(progressPercentage, 0, 100);
};